import { CbhFeatureFlag } from "@src/appV2/FeatureFlags/CbhFeatureFlag";
import { useCbhFlag } from "@src/appV2/FeatureFlags/useCbhFlag";

export function usePayPreferenceFilterSettings() {
  return useCbhFlag(CbhFeatureFlag.PAY_PREFERENCE_FILTER_SETTINGS, {
    defaultValue: {
      enabled: false,
      qualificationRanges: {},
    },
  });
}
